// TODO test
export const incrementInRange = (
  val: number,
  increment: number,
  min: number,
  max: number
) => {
  const nextIndex = (val + increment) % max;
  return nextIndex >= min ? nextIndex : nextIndex + max;
};

export const incrementInRangeWithUpperBound = (
  val: number,
  increment: number,
  max: number
) => (val + increment <= max ? val + increment : max);
